import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import Cookies from 'universal-cookie';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const getHostScheduleOverviewResponse = async (response) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const schedules = response?.schedules?.map((schedule) => {
    const startDate = new Date(schedule.startedAt);
    const endDate = new Date(schedule.endedAt);

    return {
      id: schedule.id,
      title: schedule?.title || '-',
      achievementStatus: schedule?.achievementStatus && schedule?.achievementStatus !== 'Hide Achievement' ? schedule?.achievementStatus : '',
      datetime: `${format(startDate, 'dd MMM yyyy')} | ${formatInTimeZone(startDate, timezone, 'HH:mm')}-${formatInTimeZone(endDate, timezone, 'HH:mm')}`,
      account:
        schedule.accountLivestreams?.map((account) => {
          return {
            name: account?.name,
            ecommerce: account?.ecommerce,
          };
        }) || [],
      platform: schedule.accountLivestreams.map((acc) => acc.ecommerce.name).join(', '),
      room: schedule?.studio?.room || '-',
      studio: schedule?.studio?.name || '-',
      host: schedule?.hosts.length ? schedule?.hosts.map((h) => h.name).join(' | ') : '-',
      operator: schedule?.operators?.length ? schedule.operators.map((op) => op.name).join(' | ') : '-',
      badge: false,
      isAvailable: false,
      isCanRequestReschedule: schedule?.isCanRequestReschedule,
      reschedule: schedule?.reschedule,
      rawData: schedule,
    };
  });

  await delay(1000);

  return schedules;
};

export default getHostScheduleOverviewResponse;
